<template>
  <v-container fluid pt-0>
    <v-card flat color="background">
      <v-card-title>Basic Information</v-card-title>
      <v-card-subtitle>Configure basic store information on this page</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field v-model="location.name" name="Name" label="Name"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field v-model="location.display_name" name="Display Name" label="Display Name"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field v-model="location.internal_id" name="Internal_Id" label="Internal Id"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field v-model="location.slug" name="Slug" label="Slug"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-switch inset v-model="location.is_corporate" label="Corporate"></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="updateLocation" color="primary">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
    <v-card flat color="background" v-if="isSuperUser()">
      <v-card-title>Location Type:</v-card-title>
      <v-card-subtitle>Select what matches best to your location: UNOApp users only</v-card-subtitle>
      <v-card-text>
        <v-checkbox
          class="ma-0"
          hide-details
          v-for="item in locationTypes"
          :key="item.display_name"
          @change="handleLocationTypeChange(item)"
          :label="item.display_name"
          v-model="item.is_active"
        ></v-checkbox>
      </v-card-text>
    </v-card>
    <!-- <v-card flat color="background">

    </v-card>-->
  </v-container>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
export default {
  mounted() {
    this.getLocation()
    this.getLocationTypes()
  },
  data() {
    return {
      location: {},
      locationTypes: []
    }
  },
  methods: {
    async getLocation() {
      let response
      try {
        response = await LocationAPI.getLocationById(this.$route.params.id, { contact: true })
      } catch (error) {
        return console.log(error)
      }
      this.location = response.data.payload
    },
    async updateLocation() {
      let response
      try {
        response = await LocationAPI.updateLocationById(this.$route.params.id, this.location)
      } catch (error) {
        return console.log(error)
      }
      this.location = response.data.payload
      this.swal({ title: 'Success', text: 'Location details updated successfully.', timer: 3000 })
    },
    async getLocationTypes() {
      let response
      try {
        response = await LocationAPI.getLocationTypes(this.$route.params.id)
      } catch (error) {
        return console.log(error)
      }
      this.locationTypes = response.data.payload
    },
    handleLocationTypeChange(item) {
      console.log(this.isSuperUser())
      if (item.is_active) {
        this.addLocationType(item)
      } else {
        this.removeLocationType(item)
      }
    },
    async addLocationType(item) {
      try {
        await LocationAPI.addLocationType(this.$route.params.id, { value: item.value })
      } catch (error) {
        item.value = !item.value
        return console.log(error)
      }
      this.snackbar({ text: 'Location type added successfully to location', color: 'success', icon: 'check' })
    },
    async removeLocationType(item) {
      try {
        await LocationAPI.removeLocationType(this.$route.params.id, item.value)
      } catch (error) {
        item.value = !item.value
        return console.log(error)
      }
      this.snackbar({ text: 'Location type removed from the location', color: 'warning' })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
